<template>
  <pages-wrapper>
    <div class="faq-page">
      <h1 class="faq-page-title">
        {{ pageTitle }}
      </h1>

      <p>
        Для поиска ответа на свой вопрос вы можете воспользоваться статьями информационного раздела ниже или связаться с нами одним из удобных для вас способов.
      </p>
      <p>
        Служба поддержки пользователей работает ежедневно с 7:00 до 22:00 (время московское).
      </p>
      <ul>
        <li><span>Отправить сообщение:&nbsp;<a href="mailto:helpme@fundayshop.com">helpme@fundayshop.com</a></span></li>
        <li>Связаться по телефону: 8 800 770-01-01 (по России бесплатно)</li>
      </ul>

      <h2>Ограничения, связанные с COVID-19</h2>

      <ui-accordion
        class="faq-page-questions"
        :items="covidQuestions"
      />

      <h2>Оформление заказа</h2>

      <ui-accordion
        class="faq-page-questions"
        :items="orderQuestions"
      />

      <h2>Доставка</h2>

      <ui-accordion
        class="faq-page-questions"
        :items="deliveryQuestions"
      />

      <h2>Оплата заказа</h2>

      <ui-accordion
        class="faq-page-questions"
        :items="paymentQuestions"
      />

      <h2>Обмен и возврат</h2>

      <ui-accordion
        class="faq-page-questions"
        :items="returnExchangeQuestions"
      />

      <h2>Акции</h2>

      <ui-accordion
        class="faq-page-questions"
        :items="promoQuestions"
      />

      <h2>О компании</h2>

      <ui-accordion
        class="faq-page-questions"
        :items="aboutCompanyQuestions"
      />

      <h2>Подарочная карта</h2>

      <ui-accordion
        class="faq-page-questions"
        :items="giftCardQuestions"
      />

      <h2>Клубная программа</h2>

      <ui-accordion
        class="faq-page-questions"
        :items="clubQuestions"
      />
    </div>
  </pages-wrapper>
</template>

<script>
import { LOCKDOWN_MODE } from '@/consts';
/* Components */
import PagesWrapper from '../../components/info-pages/pages-wrapper';
import UiAccordion from '../../components/kit/ui-accordion/ui-accordion';
import pageMetaMixin from '@/mixins/page-meta-mixin';

export default {
  name: 'faq',

  metaInfo() {
    return this.getPageMeta({ pageTitle: this.pageTitle });
  },

  components: {
    UiAccordion,
    PagesWrapper
  },

  mixins: [pageMetaMixin],

  data() {
    return {
      pageTitle: 'Вопросы и ответы',
      covidQuestions: [
        {
          title: 'Как мне получить свой заказ в розничном магазине, если у меня нет QR-кода?/ Почему сотрудники розничного магазина не могут вынести мой оплаченный заказ?',
          description: 'Если у вас нет QR-кода, вы можете отменить заказ и оформить новый с доставкой курьером или в постамат, либо пункт выдачи PickPoint. Также ваш заказ из розничного магазина могут забрать родственники или друзья при наличии QR-кода.'
        },
        {
          title: 'Почему сотрудники розничного магазина требуют не только QR-код для входа, но и паспорт? Имеют ли они на это право?',
          description: 'Согласно правилам, установленным в магазинах в связи с эпидемиологической обстановкой в регионе, сотрудникам магазина необходимо проверить, совпадают ли данные QR-кода с паспортными данными владельца.'
        },
        {
          title: 'Как сделать возврат товара, если магазин работает по QR-коду, а его у меня нет?',
          description: 'Вы можете подождать улучшения эпидемиологической ситуации, получить QR-код, либо попросить оформить возврат родственников или друзей с QR-кодом. В этом случае понадобится чек и карта, с которой производилась оплата при безналичном способе оплаты.'
        },
        {
          title: 'Если сотрудники розничного магазина на кассе требуют надеть маску, должны ли они ее предоставлять?',
          description: 'При наличии в магазинах масок вам её предоставят, однако необходимо иметь при себе собственное средство индивидуальной защиты, в противном случае вам могут отказать в обслуживании.'
        }
      ],
      orderQuestions: [
        {
          title: 'Нужно ли регистрироваться на сайте для оформления покупки?',
          description: 'Если вы ранее не были зарегистрированы на сайте, то при оформлении заказа регистрация будет произведена автоматически на указанный вами Email. Если вы планируете регулярно делать покупки, рекомендуем пройти регистрацию – это позволит получать скидки и участвовать в акциях, а также отслеживать статус заказа.'
        },
        {
          title: 'Как можно узнать о наличии товара в магазине?',
          description: 'Информацию можно проверить на странице товара в разделе «Наличие товара», а также обратившись по номеру горячей линии 8 800 770-01-01 или по электронному адресу <a href="mailto:helpme@fundayshop.com">helpme@fundayshop.com</a>'
        },
        {
          title: 'Как продлить заказ?',
          description: 'Обратитесь по номеру горячей линии 8 800 770-01-01 или напишите нам на электронный адрес <a href="mailto:helpme@fundayshop.com">helpme@fundayshop.com</a>, и мы продлим срок хранения заказа.'
        },
        {
          title: 'Как отменить заказ?',
          description: 'Отмена заказа через личный кабинет временно недоступна. Для отмены заказа обратитесь по номеру горячей линии 8 800 770-01-01 или напишите нам на электронный адрес <a href="mailto:helpme@fundayshop.com">helpme@fundayshop.com</a>'
        },
        {
          title: 'Как узнать статус заказа?',
          description: 'Обратитесь по номеру горячей линии 8 800 770-01-01 или напишите нам на электронный адрес <a href="mailto:helpme@fundayshop.com">helpme@fundayshop.com</a>, и мы подскажем, на каком этапе находится заказ, также посмотреть статус заказа можно в личном кабинете на сайте.'
        },
        {
          title: 'Почему при заказе на сайте в заказ добавляется услуга доставки по Москве, Московской области, Санкт-Петербургу и Екатеринбургу?',
          description: 'Бесплатная услуга доставки заказа предоставляется в случае покупки товаров на сумму не менее 1 000 руб. Если покупка превысит эту сумму, услуга доставки не оплачивается.'
        }
      ],
      deliveryQuestions: [
        {
          title: 'Как узнать, есть ли доставка в мой город?',
          description: 'На данный момент доставка осуществляется практически по всем крупным городам России и их областям. Актуальные города для доставки можно узнать на сайте в разделе «Доставка» при оформлении заказа или по номеру горячей линии 8 800 770-01-01, либо по электронному адресу <a href="mailto:helpme@fundayshop.com">helpme@fundayshop.com</a>'
        },
        {
          title: 'Как я могу уточнить или изменить адрес и (или) время доставки?',
          description: 'После подтверждения заказа самостоятельно внести в него какие-либо изменения, к сожалению, невозможно. Для изменения адреса и (или) времени доставки обратитесь по номеру горячей линии 8 800 770-01-01 или напишите нам на электронный адрес <a href="mailto:helpme@fundayshop.com">helpme@fundayshop.com</a>'
        },
        {
          title: 'Как связаться с курьерской компанией?',
          description: 'Если доставка в Москве, Санкт-Петербурге, Екатеринбурге или в городах Московской, Ленинградской и Свердловской области, то информацию можно получить по номеру 8 800 770-01-01. Если доставка производится в других регионах, информацию можно получить по номеру горячей линии курьерской компании DPD (http://www.dpd.ru) 8 800 250-44-34.'
        },
        {
          title: 'Нужно ли платить за доставку при заказе товара на сайте с самовывозом из магазина?',
          description: 'Нет, доставка в магазин осуществляется бесплатно.'
        },
        {
          title: 'За какое время до доставки связывается курьер?',
          description: 'Курьер звонит за 1 час до доставки.'
        },
        {
          title: 'В течение какого срока можно забрать заказ при самовывозе из магазина?',
          description: 'Срок резерва заказа 2–3 дня. Точный срок указан в SMS.'
        }
      ],
      paymentQuestions: [{
        title: 'Могу ли я оплатить заказ банковской картой/электронными деньгами?',
        description: 'Оплатить заказ онлайн можно на нашем сайте или банковской картой курьеру. Более подробную информацию о способах оплаты можно найти в разделе «Оплата».'
      }],
      returnExchangeQuestions: [
        {
          title: 'Возможен ли обмен товара при курьерской доставке?',
          description: 'Обмен товара возможен в случае, если товар был куплен в розничном магазине. При другом способе получения, согласно Закону о защите прав потребителей, товары обмену не подлежат. Чтобы обменять товар, необходимо сделать возврат неподходящего товара и оформить новый заказ на нужный товар.',
        },
        {
          title: 'Возможен ли обмен товара того же цвета и модели, но другого размера?',
          description: 'Да, обменять товар на такой же товар другого размера возможно в розничном магазине.',
        },
        {
          title: 'Возможен ли обмен товара в другом розничном магазине, не в том, где совершена покупка?',
          description: 'Нет, оформить обмен можно только в том же розничном магазине, где был приобретён товар.',
        },
        {
          title: 'Возможен ли возврат товара в другом розничном магазине, не в том, где совершена покупка?',
          description: 'Да, вернуть товар, приобретённый в розничном магазине, можно в любом розничном магазине сети FUNDAY на территории той же страны',
        },
        {
          title: 'В течение какого времени можно вернуть неподошедший товар, какие документы нужны?',
          description: `В течение ${LOCKDOWN_MODE ? 60 : 14} дней вы гарантированно можете осуществить полный или частичный возврат купленного в розничном магазине товара, если он не подошёл вам по цвету, размеру или фасону. Более подробную информацию о процессе обмена и возврата товара можно найти в разделе «Возврат и обмен».`
        },
        {
          title: 'Как сделать возврат, если в городе нет розничного магазина?',
          description: 'Возврат товара в случае дистанционной покупки можно осуществить по почте. Более подробную информацию о процессе обмена и возврата товара можно найти в разделе «Возврат и обмен».',
        },
      ],
      promoQuestions: [
        {
          title: 'Что такое промокод?',
          description: 'Нет, оформить обмен можно только в том же розничном магазине, где был приобретён товар.',
        },
        {
          title: 'Как применить промокод?',
          description: `<ul>
            <li>Добавьте товар в корзину и перейдите к оформлению заказа.</li>
            <li>Скопируйте промокод и вставьте его в специальное поле или введите вручную. Нажмите на кнопку «Применить».</li>
            <li>Убедитесь, что стоимость товара пересчиталась автоматически.</li>
            <li>Завершите оформление заказа.</li>
            <li>Если требуется ввести другой промокод, нажмите на кнопку «Изменить».</li>
            <li>Не удаётся применить промокод? Пожалуйста, обратитесь на горячую линию 8 800 770-01-01, и мы постараемся вам помочь.</li>
            </ul>`,
        },
        {
          title: 'Промокод суммируется с бонусами, другими промокодами, скидками?',
          description: 'Промокод не суммируется с другими промокодами. При выборе товаров, участвующих в нескольких акциях одновременно, в корзине срабатывает самая выгодная акция с большим процентом скидки. <br>Как правило, промокод действует при заказе в корзине от определённой суммы, в том числе и на товары со скидкой – подробные условия применения промокода описаны в правилах каждой конкретной акции. <br>Промокод всегда суммируется с бонусами, если в правилах конкретной акции не прописано обратное. Сначала предоставляется скидка по акции, а затем списываются бонусы. <br>Чтобы получить скидку по акции, необходимо выбрать одинаковый способ доставки для всех вещей ‒ самовывоз из одного магазина либо доставку курьером. На товары с разными способами доставки и разными магазинами самовывоза акция не действует. <br>Стоимость товара с учётом скидки по акции отображается только в корзине.',
        },
        {
          title: 'Акция сработает при частичном выкупе заказа, если сумма покупки станет меньше порога действия промокода?',
          description: 'При частичном выкупе, если сумма заказа становится меньше порога действия промокода – скидка по акции отменяется. Например, промокод MAY действует при покупке от 2 000 руб. При частичном выкупе, если сумма заказа становится меньше 2 000 руб., скидка по акции аннулируется.',
        },
        {
          title: 'Начисляются ли бонусы за покупку товара с применением промокода?',
          description: 'Начисляются только акционные бонусы в период действия акции. Регулярные бонусы за товары со скидкой не начисляются.',
        },
      ],
      aboutCompanyQuestions: [
        {
          title: 'Как связаться с корпоративным отделом?',
          description: 'C корпоративным отделом можно связаться по электронному адресу <a href="mailto:corporative@fundayshop.com">corporative@fundayshop.com</a>',
        },
        {
          title: 'Как связаться с отделом кадров?',
          description: 'Информацию по трудоустройству можно получить по ссылке в разделе «Вакансии» или по электронной почте <a href="mailto:hr_funday@fundayshop.com">hr_funday@fundayshop.com</a>',
        },
      ],
      giftCardQuestions: [
        {
          title: 'Возможно ли вернуть Подарочную карту и получить денежные средства обратно?',
          description: 'Подарочные карты возврату не подлежат.',
        },
        {
          title: 'Какие номиналы Подарочных карт существуют?',
          description: 'Подарочные карты выпущены в номиналах 500, 1 000 и 2 000 рублей.',
        },
        {
          title: 'Как узнать наличие Подарочных карт в магазине?',
          description: 'Подарочные карты разных номиналов всегда есть в розничных магазинах в количестве 5-7 штук. Более точную информацию можно узнать по номеру горячей линии 8 800 770-01-01 или по электронной почте <a href="mailto:helpme@fundayshop.com">helpme@fundayshop.com</a>.',
        },
        {
          title: 'Возможно ли двумя Подарочными картами оплатить одну покупку?',
          description: 'Да, это возможно.',
        },
        {
          title: 'Если сумма покупки будет меньше номинала Подарочной карты, что произойдёт с остатком?',
          description: 'Остаток на Подарочной карте сгорает, карта изымается сотрудниками магазина. Рекомендуем использовать номинал карты полностью.',
        },
      ],
      clubQuestions: [
        {
          title: 'Что такое Клубная программа FUNDAY?',
          description: 'Это программа поощрений для покупателей FUNDAY. Участнику программы при выполнении различных условий (совершение покупок, заполнение актуальных анкетных данных и т.д.) предоставляются выгодные предложения, скидки.'
        },
        {
          title: 'Как стать участником Клубной программы FUNDAY?',
          description: 'При совершении покупки в розничном магазине FUNDAY заполните анкету участника и получите Клубную карту или пройдите регистрацию в Клубной программе на сайте <a href="https://fundayshop.com/">www.fundayshop.com</a>, заполнив все обязательные поля в регистрационной форме.'
        },
        {
          title: 'Как будет использована информация, указанная мной в анкете при регистрации в Клубной программе?',
          description: 'Информация будет использована для: <ul><li>формирования и отправки наиболее интересных вам предложений</li><li>совершения покупок без Клубной карты – через SMS-авторизацию по номеру телефона, указанного в контактных данных</li><li>восстановления Клубной карты в случае её утраты</li></ul>'
        },
        {
          title: 'Могу ли я передавать свою Клубную карту друзьям или родственникам?',
          description: 'Клубная карта не является именной и действует на предъявителя. Вы можете передавать свою карту друзьям или родственникам для накопления и/или траты бонусов. Но переоформить Клубную карту на другое имя или узнать бонусный баланс может только владелец (указан при заполнении анкеты участника Клубной программы) Клубной карты.'
        },
        {
          title: 'Как поменять мою контактную информацию?',
          description: 'Войдите в личный кабинет на сайте, здесь вы можете изменить или дополнить вашу контактную информацию (Email и номер телефона). Для сохранения изменений нажмите кнопку «Сохранить». Обновлённые данные поступят в базу данных в режиме реального времени. <br><br>Вы также можете заполнить анкету в магазине с новыми данными. Информация поступит в систему после обработки анкеты в срок до 3-х месяцев.'
        },
        {
          title: 'Что такое бонусы?',
          description: 'За выполнение различных условий – совершение покупок, заполнение анкетных данных, участие в акциях – вам могут быть зачислены подарочные бонусы. 1 бонус равен 1 рублю.'
        },
        {
          title: 'Какой курс оплаты товара бонусами?',
          description: '1 бонус = 1 рублю.'
        },
        {
          title: 'Как накапливаются бонусы?',
          description: 'За покупки начисляется 25 бонусов за каждые полные 500 рублей в чеке при условии, что на товар не установлена скидка. На часть покупки, оплаченную бонусами, бонусы не начисляются. На покупки до 500 рублей бонусы не начисляются.'
        },
        {
          title: 'В каких магазинах я могу использовать бонусы?',
          description: 'Списание бонусов возможно во всех магазинах FUNDAY на территории Российской Федерации, а также в интернет-магазине <a href="https://fundayshop.com/">www.fundayshop.com</a>'
        },
        {
          title: 'На какие покупки я могу потратить бонусы?',
          description: 'Бонусами можно оплатить любой товар, в том числе товар со скидкой.'
        },
        {
          title: 'Какую сумму покупки я могу оплатить бонусами?',
          description: 'Бонусами можно оплатить до 30% от итоговой стоимости товара. Бонусы не могут быть использованы на оплату доставки при заказе в интернет-магазине.'
        },
        {
          title: 'Сколько времени действительны накопленные бонусы?',
          description: 'Бонусы имеют срок действия. Неиспользованные бонусы аннулируются 11 марта ежегодно. Бонусы, начисленные с 1 января по 10 марта текущего года, не аннулируются, а действуют до 11 марта следующего года. Накопленная сумма покупок по Клубной карте сохраняется. Бонусы, полученные в рамках специальных акций, аннулируются по правилам данных акций.'
        },
        {
          title: 'Когда бонусы появятся на моем счёте?',
          description: 'Бонусы появятся на счёте через сутки после покупки в магазине FUNDAY. И в течение 10 рабочих дней после оплаты заказа при покупке в интернет-магазине <a href="https://fundayshop.com/">www.fundayshop.com</a>.'
        },
        {
          title: 'Если я возвращаю товар, что произойдёт с моими бонусами?',
          description: 'При возврате товара бонусы, начисленные за эту покупку, будут аннулированы. Если бонусы за возвращаемый товар уже использованы, то бонусный счёт может стать отрицательным. В этом случае воспользоваться бонусной скидкой можно только после пополнения бонусного счёта на карте. <br>Бонусы, полученные в рамках специальных акций, возвращаются согласно правилам данных акций.'
        },
        {
          title: 'Что делать, если совершённая мной покупка не учтена на бонусном балансе или за неё не зачислены бонусы?',
          description: `Если по какой-либо причине совершённая вами покупка не учтена на бонусном балансе или за неё не зачислены бонусы, обратитесь по телефону горячей линии 8 800 770-01-01 или по электронной почте <a href="mailto:fc@fundayshop.com">fc@fundayshop.com</a>, указав при этом:
          <ul><li>номер мобильного телефона, который вы указывали при регистрации в Клубной программе</li>
          <li>номер Клубной карты</li>
          <li>номера чека (номер ПР-… - он указан на чеке), а также адрес магазина, в котором была совершена данная покупка.</li></ul>`
        },
        {
          title: 'Если я потерял Клубную карту, могу ли я её восстановить?',
          description: 'Да, утерянную карту можно восстановить. Для этого нужно обратиться к администратору любого магазина-участника Клубной программы FUNDAY. Все накопленные бонусы и общая сумма покупок перейдёт на новую Клубную карту.Об утере Клубной карты необходимо как можно скорее сообщить по телефону 8 800 770-01-01 или на <a href="mailto:fc@fundayshop.com">fc@fundayshop.com</a>, так как накопленные бонусы могут потратить до того, как вам выдадут новую карту. Восстановить бонусы в этом случае будет невозможно.'
        },
        {
          title: 'Как и где я могу проверить состояние своего бонусного счёта?',
          description: 'Бонусный баланс можно проверить в личном кабинете на сайте <a href="https://fundayshop.com/">www.fundayshop.com</a>, обратившись по телефону горячей линии 8 800 770-01-01, либо по электронной почте <a href="mailto:fc@fundayshop.com">fc@fundayshop.com</a>'
        },
        {
          title: 'Как и где узнать о специальных предложениях?',
          description: 'В магазинах FUNDAY, на сайте <a href="https://fundayshop.com/">www.fundayshop.com</a>, на страницах FUNDAY в социальных сетях, по телефону 8 800 770-01-01, через SMS и Email-рассылки. Подпишитесь на новости любым удобным для вас способом (SMS или Email), чтобы не пропустить выгодные предложения FUNDAY.'
        },
        {
          title: 'Как отказаться от получения сообщений на телефон/ Email?',
          description: `Выберите один из удобных способов: <ul><li><span>Оставьте заявку по телефону 8 800 770-01-01 или на <a href="mailto:fc@fundayshop.com">fc@fundayshop.com</a>. Запрос будет обработан в течение 5 рабочих дней</span></li><li><span>Зарегистрируйте вашу Клубную карту в личном кабинете на сайте <a href="www.fundayshop.com">www.fundayshop.com</a> и во вкладке «Подписки» измените их статусы.</span></li></ul>`
        },
        {
          title: 'Могу ли я получить или потратить бонусы, если забыл Клубную карту?',
          description: 'Вам не нужно беспокоиться, что вы забыли пластиковую карту. <br>Для того, чтобы учесть вашу покупку в Клубной программе, достаточно назвать кассиру номер телефона, указанный при регистрации. <br>В случае списания бонусов при покупке необходимо сообщить кассиру код, который вы получите в SMS.'
        },
        {
          title: 'Могу ли я использовать бонусы на оплату Подарочной карты?',
          description: 'Нет. Бонусами нельзя оплатить покупку Подарочной карты. За товар, оплаченный Подарочной картой, бонусы начисляются на сумму, превышающую номинал карты.'
        },
        {
          title: 'Что делать, если я не нашёл ответ на свой вопрос?',
          description: 'Если у вас остались вопросы, на которые вы не нашли ответ в этом разделе, обратитесь на горячую линию 8 800 770-01-01 или по электронной почте <a href="mailto:fc@fundayshop.com">fc@fundayshop.com</a>.'
        }
      ],
    }
  },
};
</script>

<style lang="scss">
.faq-page {
  h1::after {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    margin-top: 12px;
    background-color: $gray_lu;
  }

  h2 {
    margin-top: 32px;
    margin-bottom: 0;
  }

  p {
    margin-top: 12px;
  }

  &-questions {
    margin-top: 12px;
  }
}

@include breakpoint("desktop") {
  .faq-page {
    h1::after {
      margin-top: 16px;
    }

    h2 {
      margin-top: 48px;
    }

    p {
      margin-top: 16px;
    }

    &-questions {
      margin-top: 16px;
    }
  }
}
</style>
